import './App.css';
import React, { useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import PublicRotas from './routes/public-routes';
import Layout from './Layout';
import { AuthContext } from './context/AuthContext';
import { AdminContext } from './context/AdminContext';
import RotasAdmin from './routes/routes-admin';
import { ApiContext } from './context/ApiContext';
import SemEmpresa from './pages/SemEmpresa/SemEmpresa';

function App() {

  const { Auth } = useContext(AuthContext)
  const { AuthAdmin } = useContext(AdminContext)
  const { Empresas, SemEmpresaVinculada } = useContext(ApiContext)

  return (Auth && Empresas?.length > 0) ? <Layout />
    : (Auth && SemEmpresaVinculada) ? (<BrowserRouter><SemEmpresa /></BrowserRouter>)
    : AuthAdmin ? <RotasAdmin /> : <PublicRotas />

}

export default App;